import { t } from 'i18next';
import { ReactElement, useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { PlacesType } from 'react-tooltip';
import Home from '../../../../components/svg/Home';
import { SidebarProps } from './SidebarProps';
import { Thunk } from '../../../../dux/@types';
import { useDispatch } from 'react-redux';
import { checkPermission } from '../../../../dux';
import { g as abilityGlossary } from '../../../../config/ability';
import GateTooltip from '../../../Shared/Tooltips/TooltipGate';

const sidebarEventKey = 'SIDEBAR_DASHBOARD';

const DashboardSidebarSection = (props: SidebarProps): ReactElement => {
  const { onNavClick } = props;

  const dispatch = useDispatch();
  const [tooltipPlacement, setTooltipPlacement] = useState<PlacesType>('right');

  useEffect(() => {
    const handleResize = (): void => {
      const newPlace = window.innerWidth <= 768 ? 'top' : 'right';
      setTooltipPlacement(newPlace as PlacesType);
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const canViewDashboard = (): Thunk<boolean> => {
    return dispatch(
      checkPermission(abilityGlossary.VIEW, abilityGlossary.SIDEBAR_DASHBOARD, true),
    );
  };

  const customGateTooltipContent = (
    <Trans
      components={{
        dashboardLink: <a href={t('urls.pricingPage')} target="_blank" />,
        gate: <p className="tooltip-header" />,
      }}
      i18nKey="featureGating.tooltipText.dashboard"
      key="featureGating.tooltipText.dashboard"
    />
  );

  return (
    <span id={sidebarEventKey}>
      <div className={`card ${!canViewDashboard() ? 'disabled' : ''}`}>
        <NavLink
          activeClassName="active-nav-link"
          className="card-header d-flex flex-row"
          exact
          onClick={onNavClick}
          to="/dashboard"
        >
          <span className="sidebar-icon">
            <Home height="18" width="18" />
          </span>
          <h2 className="title">Dashboard</h2>
        </NavLink>
      </div>
      {!canViewDashboard() && (
        <GateTooltip
          accountType="pro"
          anchorId={sidebarEventKey}
          customContent={customGateTooltipContent}
          place={tooltipPlacement}
        />
      )}
    </span>
  );
};

export default DashboardSidebarSection;
